import { useState, useEffect } from 'react';
import {
  filterByCondition,
  filterByDateRange,
  filterBySearchQuery,
} from './filterUtils';

const useFilteredResults = (results, filters) => {
  const [filteredResults, setFilteredResults] = useState(results);

  useEffect(() => {
    let filteredData = [...results];

    filteredData = filterByCondition(
      filteredData,
      filters.competenceFilter,
      'course_competences',
      true
    );
    filteredData = filterByCondition(
      filteredData,
      filters.educationFilter,
      'course_education_type',
      true
    );
    filteredData = filterByCondition(
      filteredData,
      filters.learningFormatFilter,
      'course_learning_format'
    );
    filteredData = filterByCondition(
      filteredData,
      filters.professionalGroupFilter,
      'course_professional_group',
      true
    );
    filteredData = filterByCondition(
      filteredData,
      filters.providerFilter,
      'course_provider_area'
    );
    filteredData = filterByDateRange(
      filteredData,
      filters.startDateFilter,
      filters.endDateFilter
    );

    filteredData = filterBySearchQuery(filteredData, filters.searchQuery);

    //sorting
    if (filters.resultSort === 1) {
      filteredData.sort((a, b) => {
        if (a.training_start_time !== null || b.training_start_time !== null) {
          return 0;
        } else if (
          new Date(a.training_start_time) > new Date(b.training_start_time)
        ) {
          return 1;
        } else {
          return -1;
        }
      });
    } else if (filters.resultSort === 2) {
      filteredData.sort((a, b) => {
        if (new Date(a.training_start_time) < new Date(b.training_start_time)) {
          return 1;
        } else {
          return -1;
        }
      });
    } else if (filters.resultSort === 3) {
      filteredData.sort((a, b) => {
        if (a.title > b.title) {
          return 1;
        } else {
          return -1;
        }
      });
    } else if (filters.resultSort === 4) {
      filteredData.sort((a, b) => {
        if (a.title < b.title) {
          return 1;
        } else {
          return -1;
        }
      });
    } else {
      filteredData.sort((a, b) => {
        if (new Date(a.created) < new Date(b.created)) {
          return 1;
        } else {
          return -1;
        }
      });
    }

    setFilteredResults(filteredData);
  }, [
    results,
    filters.competenceFilter,
    filters.educationFilter,
    filters.learningFormatFilter,
    filters.professionalGroupFilter,
    filters.startDateFilter,
    filters.endDateFilter,
    filters.searchQuery,
    filters.resultSort,
    filters.providerFilter,
  ]);

  return filteredResults;
};

export default useFilteredResults;
